import Accordion from "./components/accordion";

document.addEventListener('DOMContentLoaded', () => {
    
    const tooltip = document.querySelectorAll('.tooltip');
    const toggler = document.querySelectorAll('[data-toggle]');
    const submenu = document.querySelectorAll('.menu-item-has-children');
    const solutionsMenu = document.querySelector('.submenu-wrapper--solutions');

    if (toggler.length > 0) {
        toggler.forEach((item, i) => {
            item.addEventListener('click', () => {
                document.body.classList.toggle(item.dataset.toggle);
            });
        })
    }

    if (tooltip.length > 0) {
        tooltip.forEach((item) => {
            const im = item.querySelector('img');
            if (im && im.hasAttribute('alt')) {
                const alt = im.alt;
                im.alt = '';
                const newHtml = document.createElement('span');
                newHtml.setAttribute('data-tooltip', alt);
                //newHtml.innerHTML = im;
                item.insertBefore(newHtml, im);
                newHtml.append(im);
            }
        });
    }

    const accordion = new Accordion('.has-sublist', '.more');
    const faq = new Accordion('.faq_section', '.wp-block-heading');
    
    if (submenu.length > 0) {
        submenu.forEach((item, i) => {
            item.querySelector('a').addEventListener('click', (e) => {
                e.preventDefault();
                item.classList.toggle('active');
            });
            
        })
        
        
        if (solutionsMenu) {

            const defaultSolution = solutionsMenu.querySelector('li.current-menu-item a');
            const defaultDecription = (defaultSolution) ? defaultSolution.dataset['description'] : '';
            updateItemDescription(defaultDecription);
            
            solutionsMenu.querySelectorAll('li').forEach((item, i) => {
                item.addEventListener('mouseover', (e) => {
                    const menuItemDescription = item.querySelector('a').dataset['description'];
                    updateItemDescription(menuItemDescription);
                });
                item.addEventListener('mouseleave', (e) => {
                    updateItemDescription(defaultDecription);
                });
            });
        }
    }

    function updateItemDescription(itemDescription) {
        const descriptionWrapper = document.querySelector('.submenu-body');
        descriptionWrapper.innerHTML = itemDescription;
    }

    if (parseInt(window.sessionStorage.getItem('no-modal'), 10) == 1) {
		document.body.classList.add('no-modal');
	} else {
		document.body.classList.add('modal');
	}

	if (document.querySelector('.banner-close')) {
		document.querySelector('.banner-close').addEventListener('click', ()=>{
			sessionStorage.setItem('no-modal', 1);
			document.body.classList.toggle('modal-swiched');
		})
	}
});